import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} 한국어 홈`,
    languageButtonLabel: `언어`,
    languageModalTitle: `언어 선택`,
    languageModalCloseLabel: `언어 메뉴 닫기`,
  },
  languageOptions: {
    'en-US': {
      label: `영어`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `영어 (케냐)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `영어 (나이지리아)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `영어 (싱가포르)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `포르투갈어`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `독일어`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `스페인어`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `프랑스어`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `이탈리아어`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `네덜란드어`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `북유럽 · 발트어`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `일본어`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `한국어`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `표준 중국어`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `광둥어`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `태국어`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `힌디어`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `페르시아어`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `러시아어`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `아랍어`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `모로코 아랍어`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `언어 선택`,
    closeLabel: `언어 메뉴 닫기`,
  },
  languageHint: (ctx) => `${ctx.localesCount}+개 언어로 즉시 이동.`,
  readPagePrompt: ({languageLabel}) => `이 페이지를 ${languageLabel}로 읽기.`,
};
